import { RolesStore, DropDownRolesStore } from './roles-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new RolesStore());
  storeBuilder.addRepository(new DropDownRolesStore());
}
